import React from "react";
import {
  LayoutDashboard,
  Pencil,
  CircleUserRound,
  Boxes,
  CalendarCheck2,
  ChartLine,
  MessageCircleDashed,
  FolderOpen,
  UsersRound,
  Share2,
} from "lucide-react";

// Стандартные стили для всех иконок
const defaultProps = {
  size: 20,
  strokeWidth: 1.5,
  color: "var(--icon-color)", // Используем CSS переменную
};

// Обёртка для создания единообразных иконок
const createLucideIcon = (LucideComponent, customProps = {}) => {
  return (props) => (
    <LucideComponent {...defaultProps} {...customProps} {...props} />
  );
};

// Экспортируемые иконки для меню
export const DashboardIcon = createLucideIcon(LayoutDashboard);
export const EditIcon = createLucideIcon(Pencil);
export const AccountIcon = createLucideIcon(CircleUserRound);
export const ScheduleIcon = createLucideIcon(CalendarCheck2);
export const DraftIcon = createLucideIcon(Boxes);
export const ReportsIcon = createLucideIcon(ChartLine);
export const SupportIcon = createLucideIcon(MessageCircleDashed);
export const FolderIcon = createLucideIcon(FolderOpen);
export const TeamIcon = createLucideIcon(UsersRound);
export const FacebookPagesIcon = createLucideIcon(Share2);

const LucideIcons = {
  DashboardIcon,
  EditIcon,
  AccountIcon,
  ScheduleIcon,
  DraftIcon,
  ReportsIcon,
  SupportIcon,
  FolderIcon,
  TeamIcon,
  FacebookPagesIcon,
};

export default LucideIcons;
